import React, {FC} from 'react';
import {map} from 'lodash';
import Arrow from 'templates/reports/_shared/Arrow';
import {Section as Query} from 'templates/reports/query';
import {Section as Config} from 'templates/reports/types';
import {ordinalSuffix} from 'utils/ordinal';

import Square from './Square';

import * as styles from './styles.module.scss';

interface DataTableProps {
	data: Query
	cfgs: Config['details']['table']
	reverse?: boolean
}

const fmtPct = (n: number) => (
	`${n}${ordinalSuffix(n)} percentile`
);

const DataTable: FC<DataTableProps> = ({data, cfgs, reverse}) => {
	const prev = (i: number) => {
		if (i + 1 < data.results.length) {
			return data.results[i + 1];
		}
		return null;
	};

	return (
		<div className={styles.wrapper}>
			<h2>
				{cfgs.title}
			</h2>
			<table className={styles.table}>
				<thead>
					<tr>
						<th>Date</th>
						<th>{cfgs.heading}</th>
						<th>Percentile</th>
					</tr>
				</thead>
				<tbody>
					{map(data.results, (r, i) => (
						<tr key={i}>
							<td>
								{r.start.full}
							</td>
							<td>
								<div className={styles.value}>
									{cfgs.arrow && (
										<Arrow
											curr={r}
											prev={prev(i)}
											color={reverse ? 'reverse' : 'standard'}
										/>
									)}
									<span>
										{cfgs.fmt(r.value)}
									</span>
								</div>
							</td>
							<td>
								<div className={styles.percentile}>
									<Square
										breaks={data.historicals[0].breakpoints}
										value={r.percentile}
										reverse={reverse}
									/>
									<span>
										{fmtPct(r.percentile)}
									</span>
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default DataTable;
